import { memo } from "react";
import { CHAT_MAX_PROMPT_LENGTH } from "../constants";

const ChatComposerTextarea = ({
  t,
  textareaRef,
  inputValue,
  onInputChange,
  onKeyDown,
  loading,
  hasPromptPermission,
  maxTextareaHeight,
  isCompact,
}) => (
  <textarea
    ref={textareaRef}
    rows={1}
    placeholder={
      hasPromptPermission ? t("chat.placeholder") : t("chat.no_permission")
    }
    value={inputValue}
    onChange={(e) => onInputChange(e.target.value)}
    onKeyDown={onKeyDown}
    disabled={loading || !hasPromptPermission}
    maxLength={CHAT_MAX_PROMPT_LENGTH}
    style={{ maxHeight: maxTextareaHeight }}
    className={`flex-1 bg-transparent border-none text-text-strong placeholder-text-subtle focus:outline-none py-2 px-0.5 resize-none overflow-y-auto leading-5 ${
      isCompact ? "text-xs" : "text-sm"
    }`}
  />
);

export default memo(ChatComposerTextarea);
